import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import { useTranslation } from 'react-i18next';

import ErrorBoundary from './ErrorBoundary';

function Footer() {
  const { t } = useTranslation('footer');
  return (
    <ErrorBoundary>
      <footer>
        <div>
          <span id="version">
            <Link to="/">Sensotrend Dashboard</Link> {`v.${process.env.REACT_APP_VERSION}`}
          </span>
        </div>
        <div>
          <span id="copyright">&copy; 2021 <a href="/">Sensotrend Oy</a></span>
        </div>
        <div>
          <span><Link to="/eula">{t('Terms')}</Link></span>
          <span><Link to="/privacy">{t('Privacy')}</Link></span>
          <span><Link to="/help">{t('Help')}</Link></span>
          <span><Link to="/feedback">{t('Feedback')}</Link></span>
        </div>
      </footer>
    </ErrorBoundary>
  );
}

export default Footer;
